export enum SORT_DIRECTION {
  ASC = 'ASC',
  DESC = 'DESC'
}
